/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 30 de 04 de 2026
 */
import {getDeviceTypeById} from "../../../../hooks/deviceTypeEnum";
import SummaryItem from "./SummaryItem";
import {AccessDevicesTitle, IconCalendarPaid, IconCardSettings} from "../../../../components/buttons/IconButtons";
import React from "react";
import {useSelector} from "react-redux";
import {MODE_MODEL} from "../Model/Model";
import {getModeModelKeyById} from "../../../../Apis/functions";
import {STATUS_MODEL} from "../../../../enums/statusEnum";

const SummaryContainerDetails = ({data,t}) => {

    const itemsA = [
        {
            label: 'device_type',
            value: getDeviceTypeById(data?.deviceType)?.trans
        },
        {
            label: 'zone',
            value:  data?.zone
        },
        {
            label: 'device_access_type',
            value: data?.accessType
        },
        {
            label: 'ip_domain',
            value: data?.ip
        },
        {
            label: 's_n',
            value: data?.sn
        },
        {
            label: 'status',
            value:  data?.status === STATUS_MODEL.ACTIVE_COMPANY ? t('active').toUpperCase() : t('inactive').toUpperCase()
        },
    ];
    const itemsB = [
        {
            label: 'device_name',
            value: data?.deviceName
        },
        {
            label: 'device_id',
            value: data?.idDevice
        },
        {
            label: 'mode',
            value: getModeModelKeyById(data?.modeId)
        },
        {
            label: 'mac',
            value: data?.mac
        },
        {
            label: 'password',
            value: data?.password && '***********'
        },
        {
            label: 'description',
            value: data?.description
        }
    ];

    return (
        <div className={"row p-12px"}>
            <div className={"maxw-5 col-1 p-0 d-none d-md-block"}>
                <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center
                align-items-center w-44px h-44px'>
                    <AccessDevicesTitle width={24} height={24}/>
                </div>
            </div>
            <div className={"col-12 col-md-11 row p-0"}>
                <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                    {itemsA.map((item) => (
                        <SummaryItem
                            label={item.label}
                            value={item.value}
                            t={t}
                        />

                    ))}
                </div>
                <div className={"col-12 col-md-6 gap-12px d-flex flex-column"}>
                    {itemsB.map((item) => (
                        <SummaryItem
                            label={item.label}
                            value={item.value}
                            t={t}
                        />
                    ))}
                </div>

            </div>
        </div>
    )

}

export default SummaryContainerDetails
